import { gql } from '@apollo/client';
import { QUOTE_FIELDS_FRAGMENT } from './fragments';

export const GET_QUOTE_BY_ID = gql`
  query QuoteById($quoteId: ID!) {
    quote {
      quoteById(quoteId: $quoteId) {
        error
        success
        entity {
          ...QuoteFields
        }
      }
    }
  }
  ${QUOTE_FIELDS_FRAGMENT}
`;
